// extracted by mini-css-extract-plugin
module.exports = {"formControl":"CurrencyPicker_formControl__ZmJTQ"};